'use client'
import { Accordion, Box, Text } from '@mantine/core'
import { ReactNode } from 'react'

import CaretDown from '@/assets/icons/caret-down.svg'

import styles from './style.module.css'

interface QuestionItemProps {
  question: string
  answer: ReactNode
  value: string
  isLast?: boolean
  preserveWhitespace?: boolean
}

export default function QuestionItem({
  question,
  answer,
  value,
  isLast = false,
  preserveWhitespace = false,
}: QuestionItemProps) {
  return (
    <Box
      p={4}
      style={{
        borderBottom: isLast ? 'none' : '1px solid var(--border-surface, rgba(255, 255, 255, 0.1))',
      }}
    >
      <Accordion.Item value={value} style={{ border: 'none' }}>
        <Accordion.Control
          chevron={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <CaretDown width={20} height={20} fill="var(--text-primary, #FFFFFF)" />
            </div>
          }
          classNames={{
            control: styles.faqItem,
            chevron: styles.faqChevron,
          }}
          className={styles.accordionControl}
        >
          <Text
            variant="body"
            component="h3"
            mr={8}
            style={{
              flex: 1,
              color: 'var(--text-primary, #FFFFFF)',
            }}
          >
            {question}
          </Text>
        </Accordion.Control>
        <Accordion.Panel className={styles.accordionPanel}>
          <Box
            pb={8}
            c="var(--text-secondary)"
            fz={14}
            fw={500}
            lh="20px"
            style={preserveWhitespace ? { whiteSpace: 'pre-line' } : undefined}
          >
            {answer}
          </Box>
        </Accordion.Panel>
      </Accordion.Item>
    </Box>
  )
}
